export default __webpack_public_path__ + "static/media/background.4e714600.png";